import React, { useContext } from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Truncate from 'common/Truncate';
import { StepContext, HorizontalStepContext } from 'components/StepForm';

import Styled from './styles';

const tooltipProps = {
  disable: true,
  tooltip: '',
};

export interface StepTitleProps {
  /** The title of the step.  */
  children: string;
  /** If true, there are children in this Step. */
  isParent?: boolean,
  /** If true, this StepLine is part of a parent Step. */
  isSubStep?: boolean;
  /** @ignore If true, indicates isPressed. */
  isPressed?: boolean;
  /** @ignore If true, indicates isLinear. */
  isLinear?: boolean;
  /** The variant for styling purposes.  */
  variant?: 'current' | 'future' | 'error' | 'warning' | 'completed';
  /* If true, the step is disabled. Sub step is also disabled if the parent Step is disabled. */
  disabled?: boolean;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any
}

/** `StepTitle`, all other props will be provided to the root component.` */
const StepTitle = React.forwardRef<HTMLElement, StepTitleProps>((props: StepTitleProps, ref) => getContext(({ theme }) => {
  const { children, theme: themeProp, isParent, variant, disabled, isSubStep, isLinear, ...otherProps } = props;
  const resolvedTheme = _merge({}, theme.STEP_FORM, themeProp.STEP_FORM);
  const stepContext = useContext(StepContext);
  const horizontalStepContext = useContext(HorizontalStepContext);
  const truncateStyle = { wordWrap: 'break-word', whiteSpace: 'break-spaces' };
  return (
    <Styled.StepTitle
      ref={ref}
      $theme={resolvedTheme.TITLE}
      $variant={variant || stepContext.variant || horizontalStepContext.variant}
      $isLinear={isLinear || stepContext.isLinear || horizontalStepContext.isLinear}
      $isParent={isParent}
      $isSubStep={isSubStep}
      disabled={disabled || stepContext.disabled || horizontalStepContext.disabled}
      {...otherProps}
    >
      <Truncate lines={1} delay={100} text={children} tooltip={tooltipProps} style={truncateStyle} />
    </Styled.StepTitle>
  );
}));

StepTitle.defaultProps = {
  theme: {},
  isSubStep: false,
  isPressed: false,
  isLinear: undefined,
  variant: 'future',
  isParent: false,
  disabled: false,
};

StepTitle.displayName = 'StepTitle';

export default StepTitle;